import { SEGMENT_STORAGE_KEY_NAVIGATION } from 'lib/segment/const'
import AuthService from 'lib/auth/auth-service'
import StateStorage from 'lib/state-storage'
import { FEATURE_TOGGLER } from 'constants/global'
import NavigationLinks from '../../links'

export const onLinkClicked = (trackingSessionKey, idx) => {
  if (trackingSessionKey) {
    sessionStorage.setItem(
      SEGMENT_STORAGE_KEY_NAVIGATION[trackingSessionKey].id,
      '',
    )
    sessionStorage.setItem(
      SEGMENT_STORAGE_KEY_NAVIGATION[trackingSessionKey].position,
      idx + 1,
    )
    sessionStorage.setItem(
      SEGMENT_STORAGE_KEY_NAVIGATION[trackingSessionKey].type,
      'account',
    )
  }
}

export const onClickSignOut = () =>
  AuthService.signOut().then(() => {
    StateStorage.removeAuthUser()
    const shop = StateStorage.getShop() || 'global'
    const language = StateStorage.getLanguage() || 'en'
    window.location.replace(`/${shop}/${language}/`)
  })

const isReadyToLinkRender = (link, country) =>
  !link ||
  (!FEATURE_TOGGLER.loyalty && link.label === 'Pomelo Perks') ||
  link.shops_to_hide?.includes(country) ||
  // Old logic value, since Link data has cache, this is to support backward compat, can be removed after.
  (link.block && link.block === country)

export const getUserOptions = (
  internationalization,
  isCreditEnable,
  isCashbackEnable,
  isMyLoyaltyEnable,
) => {
  const LinkList = new NavigationLinks(internationalization).getList().user
  return LinkList.filter((link) => {
    switch (link.code) {
      case 'credits':
        return isCreditEnable
      case 'pomeloperks':
        return isCashbackEnable
      case 'my-loyalty':
        return isMyLoyaltyEnable
      default:
        return true
    }
  }).filter((link) => !isReadyToLinkRender(link, internationalization.country))
}
